import { reactive } from '@vue/composition-api'
import * as apiContract from '@/api/contract'
import { breakComma, formatDateKanji, applicationNoIssuing } from '@/util/common'
import { PRODUCT_STATUS, PRODUCT_TYPE, PRODUCT_TYPE_NAME } from '@/util/constants'
import * as _ from 'lodash'
import * as moment from 'moment'

export const ContractHistoryOfPurchase = (props, context) => {

  const historyOfPurchase = reactive([])

  apiContract
    .listApplicationHistory()
    .then((response) => {
      const { data } = response
      if (data.status === 0) {
        // ユニークなキーがないため、データ更新時に特定ができないため一度削除し入れなおす
        historyOfPurchase.splice(0)
        historyOfPurchase.splice(0, 0, ...data.agreements)
      }
    })

  const format = {
    apNo: (date, no) => (date && no) ? '申込No.' + applicationNoIssuing(date + no) : '',
    date: (string) => formatDateKanji(string),
    allPrice: (price) => (price && price > 0) ? '' + breakComma(price) + '' : '無料',
    price: (price) => (price && price > 0) ? breakComma(price) + '円（税込）' : '無料',
    status: (agreement) => {
      // 商品から申込の状態を取得
      const status = decision.getStatus(agreement)
      const type = decision.getType(agreement)

      const word = (type === PRODUCT_TYPE.FIRST_TIME && status > PRODUCT_STATUS.WAIT_CONFRIM)
        ? '契約の申込み'
        : PRODUCT_TYPE_NAME(type)

      return word
    }
  }

  const decision = {
    adminEdit: (agreement) => _.get(agreement, 'package_lists[0].product_lists[0].method', 0) === 1,
    getStatus: (agreement) => _.get(agreement, 'package_lists[0].product_lists[0].status', 0),
    getType: (agreement) => _.get(agreement, 'package_lists[0].product_lists[0].type', 0),
    getPeriodEnd: (agreement) => _.get(agreement, 'package_lists[0].product_lists[0].period_end', 0),
    // 購入情報が含まれる契約か
    isPayment: (agreement) => {
      const status = decision.getStatus(agreement)
      const type = decision.getType(agreement)

      return status >= PRODUCT_STATUS.ORDER_RECEIVED && _.includes(PRODUCT_TYPE.IS_PAYMENT, type)
    },
    // 自動継続が含まれる契約か
    isContinue: (agreement) => {
      const status = decision.getStatus(agreement)
      const type = decision.getType(agreement)

      return type === PRODUCT_TYPE.CONTINUE
    },
    // 解約情報が含まれる契約か
    isCancel: (agreement) => {
      const type = decision.getType(agreement)
      return _.includes(PRODUCT_TYPE.IS_CANCEL, type)
    },
    // 初回申込情報（受注前）が含まれる契約か
    isFirst: (agreement) => {
      const status = decision.getStatus(agreement)
      const type = decision.getType(agreement)

      return type === PRODUCT_TYPE.FIRST_TIME && status <= PRODUCT_STATUS.WAIT_CONFRIM
    },
    // トライアル情報が含まれる契約か
    isTrial: (agreement) => {
      const status = decision.getStatus(agreement)
      const type = decision.getType(agreement)

      // return status === PRODUCT_STATUS.TRIAL && type === PRODUCT_TYPE.TRIAL
      return type === PRODUCT_TYPE.TRIAL
    },
    cancelCancelProduct: (agreement) => {
      const packageLists = agreement.package_lists
      const productLists = _.map(packageLists, pack => pack.product_lists)

      return _.filter(_.flatten(productLists), product => _.includes(PRODUCT_STATUS.CANCEL_CANCEL_PRODUCT, product.status))
    }
  }

  // ライセンス終了日の翌日を算出
  const endDate = (date) => {
    return formatDateKanji(moment(date).add(1, 'days'))
  }

  return {
    historyOfPurchase,
    format,
    formatDateKanji,
    decision,
    endDate
  }
}
